import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "data-name": "Слой 2" }, [
      _createElementVNode("g", { "data-name": "Слой 1" }, [
        _createElementVNode("path", { d: "M13.17 5.72a2.92 2.92 0 1 0 2.91 2.92 2.92 2.92 0 0 0-2.91-2.92m1.56 4.53-2-1.19v-2.5h.63v2.19l1.66 1Z" }),
        _createElementVNode("path", { d: "M19.35 6a7.49 7.49 0 0 0-14-2A6 6 0 0 0 6 16h13a5 5 0 0 0 .35-10m-8.43-2 .53.64-1.91 1.6L9 5.6Zm2.25 8.39a3.75 3.75 0 1 1 3.75-3.75 3.74 3.74 0 0 1-3.75 3.75M17 6l-.2.25-1.92-1.61.54-.64L17 5.33Z" })
      ])
    ], -1)
  ])))
}
export default { render: render }